import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiClock, FiFileText, FiPhone, FiDollarSign } = FiIcons;

const TrustSection = () => {
  const problems = [
    {
      icon: FiClock,
      title: "Weeks to get covered",
      solution: "Same-day coverage"
    },
    {
      icon: FiFileText,
      title: "Complex paperwork",
      solution: "10-minute application"
    },
    {
      icon: FiPhone,
      title: "Hard to reach agents",
      solution: "Instant online quotes"
    },
    {
      icon: FiDollarSign,
      title: "Hidden fees",
      solution: "Transparent pricing"
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Insurance <span className="text-blue-600">Reimagined</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            We've eliminated the traditional headaches of business insurance
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="text-center space-y-4">
                <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto">
                  <SafeIcon icon={item.icon} className="text-red-600 text-2xl" />
                </div>
                <div>
                  <p className="text-red-600 font-medium line-through mb-2">{item.title}</p>
                  <p className="text-green-600 font-semibold">{item.solution}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mt-16"
        >
          <motion.a
            href="https://quote.burbankinsuranceservices.com/Jn9lan"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-colors duration-300 inline-block"
          >
            See How It Works
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;